import {reactive} from 'vue'

export const FinanceConsiderStore = reactive({

    considerArr: [],

    doadd(idquestion,considerArr) {

        // Do we already have the idquestion
        let i = this.considerArr.findIndex((element) => {

            return (element.idquestion === idquestion)
        })


        if (i === -1) {
            // No
            this.considerArr.push({idquestion:idquestion,consider:considerArr})
        } else {
            // Yes - replace
            this.considerArr[i] = {idquestion:idquestion,consider:considerArr}
        }
    },

    // Remove an idquestion entry
    doremove(idquestion) {

        this.considerArr = this.considerArr.filter((element) => {
            return (element.idquestion !== idquestion)
        })
    },

    // Set the whole array
    doset(idquestion,considerArr) {
        this.considerArr = considerArr
    }

})